export default __webpack_public_path__ + "images/ffa975495895023813b8db591ce68664-realestate.webp";